"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("../../elements/Button/Button"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Link = _interopRequireDefault(require("../../elements/Link/Link"));
var _Logo = _interopRequireDefault(require("../../elements/Logo/Logo"));
var _Responsive = _interopRequireDefault(require("../../components/elements/Responsive/Responsive"));
var _HamburgerNav = _interopRequireDefault(require("../../organisms/Header/HamburgerNav"));
var _Menu = _interopRequireDefault(require("../../components/elements/Menu/Menu"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _templateObject;
var VertMenu = (0, _styledComponents.default)(_Menu.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  background: var(--bf-core-pink);\n  font-family: var(--bf-lead-font);\n  text-align: center;\n\n  a {\n    color: var(--bf-core-white) !important;\n    text-decoration: none;\n  }\n\n  .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    border: none;\n    background: none;\n    color: var(--bf-core-white);\n    font-weight: bold;\n    font-size: 18px;\n    padding: 10px;\n    width: 50px;\n    height: 50px;\n  }\n\n  .logo {\n    margin-top: 30px;\n  }\n\n  * {\n    width: 100%;\n  }\n"])));
var VerticalMenu = function VerticalMenu(_ref) {
  var links = _ref.links,
    handleClose = _ref.handleClose,
    metaQuery = _ref.metaQuery,
    post = _ref.post;
  return _react.default.createElement(VertMenu, {
    vertical: true
  }, _react.default.createElement("button", {
    className: "close",
    onClick: handleClose
  }, "\xD7"), _react.default.createElement(_Logo.default, {
    large: true,
    white: true,
    className: "logo"
  }), links.map(function (link) {
    return _react.default.createElement(_Link.default, {
      href: link.href || link.data.slug
    }, link.button ? _react.default.createElement(_Button.default, {
      inverted: true,
      white: true
    }, link.text) : _react.default.createElement(_react.default.Fragment, null, link.text || link.data.title));
  }));
};
var MobileNavigation = function MobileNavigation(_ref2) {
  var links = _ref2.links;
  var _React$useState = _react.default.useState(true),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    hideMenu = _React$useState2[0],
    $hideMenu = _React$useState2[1];
  var handleMenu = function handleMenu() {
    return $hideMenu(!hideMenu);
  };
  return _react.default.createElement(_Responsive.default, {
    maxWidth: parseInt(_bfBaseStyles.Breakpoints.m)
  }, hideMenu ? _react.default.createElement(_HamburgerNav.default, {
    handleMenu: handleMenu
  }) : _react.default.createElement(VerticalMenu, {
    links: links,
    displayVertMenu: hideMenu,
    handleClose: handleMenu
  }));
};
var _default = MobileNavigation;
exports.default = _default;